<template>
  <div class="playerprofile">

    <div class="tRowTopMain" :class="{tRowTopMainnonMobile : isMobile(true) }">
        <MiniMenu 
          :config="config"
          :seasonCode="season"
          :tour="tour"
        />
    </div>
    <div :style="backgroundColor">
      <b-container class=''>
        <!-- Desktop Verison -->
        <b-row class="above500">
          <b-col>
            <div class="NameBlock">
              <span class="fullName">{{ playerinfo.MEMBER.FULL_NAME }}</span>
              <img 
                class="flagPlayerProfile"
                :src="
                  (config.VUE_APP_FLAG_URL +
                    playerinfo.MEMBER.NATIONALITY)
                    | lowercase
                "
              />
                  <span class="socialLinks">
                    <span v-if="playerinfo.MEMBER.FACEBOOK.length">
                      <b-nav-item
                        :href="
                          'https://facebook.com/' + playerinfo.MEMBER.FACEBOOK
                        "
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'facebook-square']"
                        />
                      </b-nav-item>
                    </span>

                    <span v-if="playerinfo.MEMBER.TWITTER.length">
                      <b-nav-item
                        :href="'https://twitter.com/' + playerinfo.MEMBER.TWITTER"
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'twitter']"
                        />
                      </b-nav-item>
                    </span>

                    <span v-if="playerinfo.MEMBER.INSTAGRAM.length">
                      <b-nav-item
                        :href="
                          'https://instagram.com/' + playerinfo.MEMBER.INSTAGRAM
                        "
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'instagram']"
                        />
                      </b-nav-item>
                    </span>
                  </span> 
            </div>
          </b-col>
          <b-col class="col-md-4 profileImage" v-bind:style="{ 'background-image': 'url(' + PlayerbkImage + ')' }">
          </b-col>
        </b-row>
        <!-- Mobile Verison -->
        <b-row class="below500">
          <b-col sm="12" md="12" lg="12">
            <div class="NameBlock Mob">
              <span class="fullName">{{ playerinfo.MEMBER.FULL_NAME }}</span>
              <img 
                class="flagPlayerProfile"
                :src="
                  (config.VUE_APP_FLAG_URL +
                    playerinfo.MEMBER.NATIONALITY)
                    | lowercase
                "
              />
                  <span class="socialLinks">
                    <span v-if="playerinfo.MEMBER.FACEBOOK.length">
                      <b-nav-item
                        :href="
                          'https://facebook.com/' + playerinfo.MEMBER.FACEBOOK
                        "
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'facebook-square']"
                        />
                      </b-nav-item>
                    </span>

                    <span v-if="playerinfo.MEMBER.TWITTER.length">
                      <b-nav-item
                        :href="'https://twitter.com/' + playerinfo.MEMBER.TWITTER"
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'twitter']"
                        />
                      </b-nav-item>
                    </span>

                    <span v-if="playerinfo.MEMBER.INSTAGRAM.length">
                      <b-nav-item
                        :href="
                          'https://instagram.com/' + playerinfo.MEMBER.INSTAGRAM
                        "
                        target="_blank"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fab', 'instagram']"
                        />
                      </b-nav-item>
                    </span>
                  </span> 
            </div>
          </b-col>
          <b-col sm="12" md="12" lg="12" class="profileImage" v-bind:style="{ 'background-image': 'url(' + PlayerbkImage + ')' }">
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Ads Section -->
    <div class="adsSection">
      <template v-if="isMobile(true)">
        <div class="ad test"> 
          <div class="ad" style="text-align:center;">
            <script
              type="application/javascript"
              async
              src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
              crossorigin="anonymous"
            ></script>


              <script type="application/javascript">
                window.googletag = window.googletag || { cmd: [] };
                googletag.cmd.push(function() {
                  googletag
                    .defineSlot(
                      "/27436116/Golf_PGA_Leaderboard_Top",
                      [[320,50]],
                      "leaderboardtop"
                    )
                    .addService(googletag.pubads());
                  googletag.pubads().enableSingleRequest();
                  googletag.pubads().collapseEmptyDivs();
                  googletag.pubads().enableLazyLoad();
                  googletag.enableServices();
                });
              </script>
              <div
                id="leaderboardtop"
                style="min-width: 320px; min-height: 50px;"
                class="AdPad"
              >
                <script type="application/javascript">
                  googletag.cmd.push(function() {
                    googletag.display("leaderboardtop");
                    googletag.pubads().refresh();
                    googletag.pubads().collapseEmptyDivs();
                    googletag.pubads().enableLazyLoad();
                  });
                </script>
              </div>

          </div>
        </div>
      </template>
      <template v-else>
        <!-- Desktop Add -->
        <div class="ad test">
          <div class="ad" style="text-align:center;">
            <script
              type="application/javascript"
              async
              src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
              crossorigin="anonymous"
            ></script>


              <script type="application/javascript">
                window.googletag = window.googletag || { cmd: [] };
                googletag.cmd.push(function() {
                  googletag
                    .defineSlot(
                      "/27436116/Golf_PGA_Leaderboard_Top",
                      [[728,90],[970,90]],
                      "leaderboardtop"
                    )
                    .addService(googletag.pubads());
                  googletag.pubads().enableSingleRequest();
                  googletag.pubads().collapseEmptyDivs();
                  googletag.pubads().enableLazyLoad();
                  googletag.enableServices();
                });
              </script>
              <div
                id="leaderboardtop"
                style="min-width: 728px; min-height: 90px;"
                class="AdPad"
              >
                <script type="application/javascript">
                  googletag.cmd.push(function() {
                    googletag.display("leaderboardtop");
                    googletag.pubads().refresh();
                    googletag.pubads().collapseEmptyDivs();
                    googletag.pubads().enableLazyLoad();
                  });
                </script>
              </div>

          </div>
        </div>
      </template>
    </div>

    <div class='white'>
      <b-container class='playerData'>
        <div class="firstSection">
          <b-row class="playerProfileRow">
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.DATE_OF_BIRTH.length">
              <h3 class="playerProfileData">
                {{ playerinfo.MEMBER.DATE_OF_BIRTH }}
              </h3>
              <h4 class="playerProfileTitle">
                DATE OF BIRTH
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.DATE_TURNED_PRO.length">
                <h3 class="playerProfileData">
                  <span v-if="playerinfo.MEMBER.DATE_TURNED_PRO.length">{{ playerinfo.MEMBER.DATE_TURNED_PRO }}</span>
                  <span v-else>N/A</span>
                </h3>

              <h4 class="playerProfileTitle">
                TURNED PROFESSIONAL
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.COACH_NAME.length">
              <h3 class="playerProfileData">
                <span v-if="playerinfo.MEMBER.COACH_NAME.length">{{ playerinfo.MEMBER.COACH_NAME }}</span>
                <span v-else>N/A</span>
              </h3>
              <h4 class="playerProfileTitle">
                COACH
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.PLACE_OF_BIRTH.length">
              <h3 class="playerProfileData">
                <span v-if="playerinfo.MEMBER.PLACE_OF_BIRTH.length">{{ playerinfo.MEMBER.PLACE_OF_BIRTH }}</span>
                <span v-else>N/A</span>
              </h3>
              <h4 class="playerProfileTitle">
                PLACE OF BIRTH
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.RESIDENCE.length">
              <h3 class="playerProfileData">
                <span v-if="playerinfo.MEMBER.RESIDENCE.length">
                  {{ playerinfo.MEMBER.RESIDENCE }}
                </span>
                <span v-else>
                  N/A
                </span>
              </h3>
              <h4 class="playerProfileTitle">
                RESIDENCE
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace">
              <h3 class="playerProfileData">
                <!-- <span v-if="playerinfo.tour_name.length">{{ playerinfo.tour_name }}</span> -->
                <span>PGATA</span>
              </h3>
              <h4 class="playerProfileTitle">
                CURRENT TOURS
              </h4>
            </b-col>
            <b-col lg="3" class="infoSpace" v-if="playerinfo.MEMBER.OWGR_RANKING.length">
              <h3 class="playerProfileData">
                <a class="owgrColor" :href="'http://www.owgr.com/en/Ranking/PlayerProfile.aspx?playerID=' + playerinfo.MEMBER.WGR_REF" target="_blank">
                  {{ playerinfo.MEMBER.OWGR_RANKING }}
                </a>
              </h3>
              <h4 class="playerProfileTitle">
                OWGR
              </h4>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col>
            <p class="bioTitle">
              Biography
            </p>
            <p v-if="playerinfo.BIOGRAPHY.length" class="bio" v-html="playerinfo.BIOGRAPHY">
            </p>
            <p v-else class="bio">
              No Information
            </p>
            <p v-if="playerinfo.BIOGRAPHY2.length" class="bio" v-html="playerinfo.BIOGRAPHY2">
            </p>
            <p v-if="playerinfo.BIOGRAPHY3.length" class="bio" v-html="playerinfo.BIOGRAPHY3">
            </p>
          </b-col>
        </b-row>
        <b-row class="tableSection">
          <b-col>
            <b-tabs content-class="mt-3" class="playerblock">
              <b-tab :title="'This Season Record'" active>
                <PlayerResults
                  :data='playerinfo.THIS_SEASON_RECORD.TOURNAMENT'
                  :config="config"
                />
              </b-tab>
              <!-- <b-tab :title="'Last Season Highlights'" v-if="playerinfo.LAST_SEASON_HIGHLIGHTS.length">
                <LastSeasonHighlights
                  :data='playerinfo.LAST_SEASON_HIGHLIGHTS.TOURNAMENT'
                  :config="config"
                />
              </b-tab>
              <b-tab :title="'Order of Merit'" v-if="playerinfo.ORDERS_OF_MERIT.length">
                <Oom
                  :data='playerinfo.ORDERS_OF_MERIT.TOURNAMENT'
                  :config="config"
                />
              </b-tab> -->
              <b-tab title="Career Highlights">
                <PlayerCareerHighlights
                  :stats="playerinfo.CAREER_HIGHLIGHTS.TOURNAMENT"
                  :config="config"
                />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import MiniMenu from "@/components/miniMenu.vue";
import axios from "axios";
import PlayerResults from "@/components/playerResults.vue";
import PlayerCareerHighlights from "@/components/playerCareerHighlights.vue";
// import LastSeasonHighlights from "@/components/lastSeasonHighlights.vue";
// import Oom from "@/components/orderOfMeritplayer.vue";
export default {
  name: "playerprofile",
  components: {
    PlayerResults,
    PlayerCareerHighlights,
    // LastSeasonHighlights,
    // Oom,
    MiniMenu
  },
  props: ["refno", "seasonCode", 'config'],
  data() {
    return {
      playerinfo: [],
      enhancedPlayerInfo: [],
      tour: process.env.VUE_APP_TOUR,
      backgroundColor: {
        backgroundColor: process.env.VUE_APP_REPORT_MAIN_COLOUR,
        color: '#fff'
      },
      CurrentSeaon: '',
      PlayerbkImage: '',
    };
  },
  methods: {
    isMobile() {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },
      receiveMessage: function(event) {
        console.log("Message received:", event.data);
    }
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    },
  },
  mounted() {
    axios
      .get(
        process.env.VUE_APP_PLAYER_BASIC +
          this.refno +
          "?randomadd=" +
          new Date().getTime()
      )
      .then((response) => {
        this.playerinfo = response.data;
        this.playerName = response.data.MEMBER.FULL_NAME;
        localStorage.setItem("Player Name",  this.playerName);
        localStorage.setItem("Player Link",  this.$route.fullPath);
        console.log("this.playerinfo")
        console.log(this.playerinfo)
        window.addEventListener('message', (event) => {
          console.log('inevent');
          console.log(event.data);
        });
        this.CurrentSeaon = response.data.THIS_SEASON_RECORD.SEASON;
        this.PlayerImageMCB = response.data.IMAGE_MCB;
        this.PlayerImageMMP = response.data.IMAGE_MMP;
        this.PlayerImageMCM = response.data.IMAGE_MCM;
        this.hasImage = response.data.IMAGE;
        if (this.hasImage == 'N' && this.PlayerImageMCB == 'N' && this.PlayerImageMMP == 'N') {
          console.log('One')
          this.PlayerbkImage = 'https://ocs-aus.sgp1.cdn.digitaloceanspaces.com/pgaaus/media/photos/' + this.playerinfo.MEMBER.REFNO + '.jpg'
        } else if (this.hasImage == 'Y' && this.PlayerImageMCB == 'Y') {
           console.log('Two')
          this.PlayerbkImage = 'https://ocs-aus.sgp1.cdn.digitaloceanspaces.com/pgaaus/media/photos/' + this.playerinfo.MEMBER.REFNO + '-MCB.jpg'
        } else if (this.hasImage == 'Y' && this.PlayerImageMCB == 'N' && this.PlayerImageMMP == 'Y') {
           console.log('Three')
          this.PlayerbkImage = 'https://ocs-aus.sgp1.cdn.digitaloceanspaces.com/pgaaus/media/photos/' + this.playerinfo.MEMBER.REFNO + '-MMP.jpg'
        } else if (this.hasImage == 'Y' && this.PlayerImageMCB == 'N' && this.PlayerImageMMP == 'N') {
           console.log('Three')
          this.PlayerbkImage = 'https://ocs-aus.sgp1.cdn.digitaloceanspaces.com/pgaaus/media/photos/' + this.playerinfo.MEMBER.REFNO + '.jpg'
        }
        return axios.get(
          process.env.VUE_APP_PLAYER_ENCHANCED +
            this.CurrentSeaon +
            "/" +
            this.CurrentSeaon +
            '-players-' +
            this.refno +
            '.json'+
            "?randomadd=" +
            new Date().getTime()
        );
      })
      .then((response) => {
        this.enhancedPlayerInfo = response.data;
        // this.playerName = response.data.full_name;
        // localStorage.setItem("Player Name",  this.playerName);
        // localStorage.setItem("Player Link",  this.$route.fullPath);
      });
  },
};
</script>

<style scoped>
.NameBlock.Mob {
  margin-top: 50px;
  padding-bottom: 50px;
}
.adsSection {
  margin-top: 50px;
}
.tableSection {
  margin-top: 30px;
}
.tRowTopMainnonMobile {
  background-color: transparent!important;
}
.tRowTopMain {
  background-color: rgba(0, 0, 0, 0.04);
}
.infoSpace {
  padding-bottom: 50px;
}
.NameBlock {
  margin-top: 150px;
}
.firstSection {
  padding-bottom: 50px;
}
span.fullName {
  font-size: 60px;
  font-family: 'Gantari', sans-serif !important;
  font-weight: 600 !important;
}
.profileImage {
  height: 395px;
  background-position: center;
  background-size: cover;
}
.TopGreen {
  background-color: #74DBBB;
}
.tRow {
  border-bottom: 0px solid #000;
  padding: 15px 0;
  background: rgba(0, 0, 0, 0.04);
}
a.owgrColor {
  color: #00b588!important;
}
a.owgrColor:hover {
  color: #000!important;
}
::v-deep .playerblock > div > ul {
  border-bottom: 0px!important;
}
::v-deep .mt-3, .my-3 {
  margin-top: 0rem !important;
}
.playerprofile{
  /* background-color: #F9f9f9; */
  padding-bottom: 50px;
}
.playerData{
  padding: 50px 0;
}
.titleCont {
  position: relative;
  top: 49%;
  transform: translateY(-50%);
  text-align: center;
}
li {
  list-style-type: none;
}
.playerName {
  color: #000;
  font-size: 22pt;
  width: 100%;
  display: block;
  margin-top: 0em;
  border-bottom: 1px solid #ddd;
  padding-bottom: 2px;
}
.flagPlayerProfile {
  max-height: 20px;
  box-shadow: 0px 0px 3px #555;
  margin-left: 25px;
  margin-bottom: 10px;
  border: 0.1px solid;
}
.icon {
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.socialLinks {
  /* float: right; */
}
span.socialLinks > span > li >a {
  padding-left: 5px;
}
.icon {
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-size: 25px;
  color: #fff;
}
.playerProfileData {
  font-weight: 700;
  font-size: 17px;
  color: #003C52;
}
.playerProfileTitle {
  color: #565656;
  font-size: 10pt;
  text-transform: uppercase;
  margin: 0;
}
.playerProfileRow {
  padding: 20px;
  padding-left: 0px;
  padding-right: 0px;
}
.playerImg {
  width: 100%;
}
.bioTitle {
  /* padding-left: 13px; */
  font-weight: 700;
  font-size: 17px;
  color: #003C52;
}
.bio {
  color: #565656;
  font-size: 11pt;
  margin: 0 0 10px;
  font-family: "Roboto", sans-serif !important;
  line-height: 1.42857143;
  font-weight: 300;
}
::v-deep .nav-tabs > li > a.active {
  color: #fff !important;
  cursor: default;
  background-color: #003C52;
  border-bottom-color: transparent;
  border-radius: 0px;
  /* height: 42px; */
  width: 100%;
  border: none;
}
::v-deep .nav-tabs > li > a {
  color: #fff !important;
  background-color: #000;
  border-radius: 0px;
  padding: 12px 0 10px 0px;
  text-align: center;
  font-size: 14px;
  width: 100%;
  border: none;
  font-weight: 600;
}
::v-deep .nav-tabs > li > a:hover {
  color: #fff !important;
  background-color: #000000;
  border-radius: 0px;
  padding: 12px 0 10px 0px;
  text-align: center;
  font-size: 14px;
  width: 100%;
  border: none;
}
::v-deep .nav-item {
  /* width: 50%; */
  width: 25%;
}

.white{
  background-color: white;
}
@media screen and (min-width: 769px) {
  .below500 {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .above500 {
    display: none;
  }
}
</style>
